import { Component, Inject, EventEmitter, Output } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { Zone } from '../../shared/zone.model';
import { ZoneService } from '../../shared/zone.service';
import { ZoneListComponent } from '../../zone-list/zone-list.component';
import { ZoneDetailComponent } from '../../zone-detail/zone-detail.component';

@Component({
  selector: 'app-zones-modal',
  templateUrl: './zones-modal.component.html',
  standalone: true,
  imports: [SharedModule, ZoneListComponent, ZoneDetailComponent],
})
export class ZonesModalComponent {
  // @Output() private dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  // lang = this.data.params.lang;

  zones: Zone[];
  meta = [];
  zone: Zone;
  mode = '';
  loadingZones = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_zone_accountadmin'),
    canCreate: this.abilityService.can('create_zone_accountadmin'),
  };

  defaultLanguage: any;

  private filterCriteria = this.zoneService.getFilterCriteria();
  additionalLanguages = [];

  constructor(
    private zoneService: ZoneService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private utilService: UtilService,
    private ref: MatDialogRef<ZonesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  showZones() {
    this.listMode = true;
    this.detailMode = false;

    this.getZones();
  }

  addZone() {
    this.modalTitle = 'ADD_ZONE';
    this.listMode = false;
    this.detailMode = true;

    this.zone = { name: '' };
  }

  // Referenced from app-zone-detail
  onSavedZone(zone) {
    this.zone = zone;

    this.listMode = true;
    this.detailMode = false;

    this.getZones(zone);

    // this.ref.close(zone); // close the dialog
  }

  // Referenced from app-zone-detail
  onCanceledZone() {
    this.showZones();
  }

  close() {
    // this.private .emit(true); // avoid closing the dialog
    this.ref.close(true); // close the dialog
  }

  // Referenced from app-zone-list
  onSelectedZone({ zone, mode = '' }) {
    // this.zone = zone;
    this.mode = mode;

    this.modalTitle = 'ZONE_DETAILS';
    this.listMode = false;
    this.detailMode = true;

    this.getZone(zone.id);
  }

  private getZones(selectedZone = null) {
    this.filterCriteria.lang = this.defaultLanguage.lang;

    this.loadingZones = true;
    this.zoneService.getZones(this.filterCriteria).subscribe((response) => {
      this.zones = response.data;
      this.meta = response.meta;

      this.loadingZones = false;

      if (selectedZone) {
        this.utilService.changeItemRowStyle(selectedZone.id);
      }
    });
  }

  private getZone(zoneId) {
    this.zone = null;

    this.zoneService.getZone(zoneId).subscribe((response) => {
      this.zone = response;
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getZones();
    });
  }
}
